// utils.js (reemplazar TODO el archivo)
import axios from 'axios';
import {API_URL} from '../../../constants';

export const FLAG_RESTRINGE_GUARDAR_POR_INCUMPLIMIENTO = true;

export const fetchImageDimensions = async () => {
    const url = `${API_URL}ParametroUX/ListarParametrosPorCodigo/RECURSOS_IMG_MAXDIM`; 
    try {
        const res = await axios.get(url);
        if (res.data && res.data.isSucess && res.data.result && res.data.result.length > 0) {
            const valorString = res.data.result[0].valor;
            const parts = valorString.split('x');
            if (parts.length === 2) {
                const width = parseInt(parts[0], 10);
                const height = parseInt(parts[1], 10);
                if (!isNaN(width) && !isNaN(height)) {
                    return { width, height };
                }
            }
        }
    } catch (err) {
        console.error("Error al obtener parámetros de dimensión de imagen:", err);
    }
    return null; 
};

export const fetchImagePesoMaximo = async () => {
    const url = `${API_URL}ParametroUX/ListarParametrosPorCodigo/RECURSOS_IMG_MAXSIZE`; 
    const DEFAULT_MAX_MB = 1; 

    try {
        const res = await axios.get(url);
        if (res.data && res.data.isSucess && res.data.result && res.data.result.length > 0) {
            const valorString = res.data.result[0].valor; 
            const valorNumerico = parseFloat(valorString); 

            if (!isNaN(valorNumerico)) {
                if (valorNumerico >= 0.1 && valorNumerico <= 10) {
                    return valorNumerico; 
                }
            }
        }
    } catch (err) {
        console.error("Error al obtener el peso máximo de la imagen desde la API:", err);
    }

    return DEFAULT_MAX_MB; 
};

const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve({ width: img.naturalWidth, height: img.naturalHeight });
            URL.revokeObjectURL(img.src);
        };
        img.onerror = () => {
            reject('Error al cargar la imagen.');
            URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(file);
    });
};

export const validateImageFile = async (file, imageDimensionLimits, weightLimitBytes) => {
    if (!file) return { ok: true };

    const { width: REQUIRED_WIDTH = 380, height: REQUIRED_HEIGHT = 401 } = imageDimensionLimits || {};
    
    if (weightLimitBytes && file.size > weightLimitBytes) {
        return { ok: false, message: `La imagen supera el límite de peso permitido.` };
    }

    try {
        const dimensions = await getImageDimensions(file);
        if (dimensions.width !== REQUIRED_WIDTH || dimensions.height !== REQUIRED_HEIGHT) {
            return { ok: false, message: `La imagen debe tener dimensiones de ${REQUIRED_WIDTH}x${REQUIRED_HEIGHT} píxeles.` };
        }
    } catch (error) {
        return { ok: false, message: "El archivo de imagen seleccionado no es válido o está corrupto." };
    }
    
    return { ok: true };
};
